<template>
  <CommonTable
    list-getter="projectMeteringStore/groupStore/getMetersFromItem"
    :headers="headers"
    :slots="slots"
    :actions="actions"
    resource="groups"
    :static-dispatch-params="{ project_id: $route.params.project_id }"
  ></CommonTable>
</template>

<script>
import CommonTable from "../../../common/tables/CommonTable";
export default {
  name: "MetersGroup",
  components: {
    CommonTable
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$i18n.t("groups.name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$i18n.t("groups.serial-number"),
          value: "serial_number"
        }
      ],

      actions: [],
      slots: [
        {
          name: "name",
          type: "link",
          to: "meter"
        }
      ]
    };
  }
};
</script>

<style scoped></style>
